import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import EmailIcon from '@material-ui/icons/Email';

/* Import custom modules*/
import Layout from '../components/layout'
import SEO from "../components/seo"
import ContactForm from '../components/Custom Modules/ContactForm';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    boxShadow: 'none',
    fontSize: '16px',
    color: '#424242',
    margin: 'auto',
    maxWidth: 500,
  },
  imageDiv: {
    maxWidth: '100%',
    minWidth: '100%',
    display: 'block'
  },
  image: {
    width: '100%',
    height: '100%',
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  heading:{
    fontSize:'16px',
    color:'#f7941e',
    marginBottom: '30px'  
  },
  paper1: {
    padding: theme.spacing(2),
    boxShadow: 'none',
    color: '#424242',
    margin: 'auto',
    maxWidth: 300,
    textAlign: 'left'
  },
  contactTab:{
      textAlign: 'center'
  },
  iconSize:{
    fontSize:60,
    color:'#003a4d'
  },
  addressBlock:{
    textAlign: 'left',
    maxWidth: 180
  },
  contactDetailsContainer:{
    marginBottom:20,
    marginTop:20,
    fontSize:24
  },
  contactDetailContainer:{
    justifyContent: 'center',
    marginBottom: 30
  },
  addressContainer:{
    marginBottom:'0.5rem'
  }
}));

export default function Contact() {
  const classes = useStyles();

  return (
    <Layout>
    <SEO 
      title="Contact us Pratiiti.com for Career counselling, Family and marriage Counsellors" 
      description="Contact us -Pratiiti.com offers counselloers for Career counselling, Family and marriage Counselling at best prices."
      canonical={"https://www.pratiiti.in/contact-us"}
    />
    <div className="contactUSBG" style={{padding:'10px', textAlign: 'center'}}>
    <div style={{textAlign: 'center'}}>
        <div className={classes.root}>
        <Grid container>
        <Grid item xs={12}>
        <iframe 
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14235.136175899992!2d75.7839292!3d26.8786015!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5d1683d967fda3e1!2sPratiiti+Luminaries+Pvt.+Ltd!5e0!3m2!1sen!2sin!4v1543314418746" 
            width="70%" 
            height="400" 
            frameBorder="0" 
            style={{border: "0"}} 
            allowFullScreen
            title="location"
        >    
        </iframe>
        </Grid>
        </Grid>

        <Grid container className={classes.contactDetailContainer}>

        <Grid item xs={12} sm={12} md={3}>
            <LocationOnIcon className={classes.iconSize}/>
            <div className={classes.contactDetailsContainer}>
            Find Us
            </div>
            <address>
            <p className={classes.addressContainer}>Pratiiti Luminaries Pvt. Ltd.</p>
            <p className={classes.addressContainer}>E-5, Mahesh Nagar</p> 
            <p className={classes.addressContainer}>Jaipur, Rajasthan - 302015</p>
            </address>
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
            <PhoneAndroidIcon className={classes.iconSize}/>
            <div className={classes.contactDetailsContainer}>
            Phone
            </div>
            <div><a style={{textDecoration: 'none', color:'#000000'}} href="tel:+91 8058066661">+91 8058066661</a></div>
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
            <EmailIcon className={classes.iconSize}/>
            <div className={classes.contactDetailsContainer}>Email</div>
            <div><a style={{textDecoration: 'none', color:'#000000'}} href="mailto:contact@pratiiti.in">pratiiti@gmail.com</a></div>
        </Grid>

        </Grid>
    </div>
    </div>
    <ContactForm/>
    </div>
    </Layout>
  );
}